module.exports = __webpack_public_path__ + "img/智能业务流程.c34e40c0.png";